import React from "react";
import { Navigate } from "react-router-dom";
export const PrivateRouter = ({ children }) => {
  //check user authenticate or not if not then redirect on login page
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" />;
};
